import LangLink from "./LangLink";
import { ChevronRight } from "lucide-react";
import { useI18n } from "../../i18n";

// Accessible breadcrumb trail. `items` = [{ name, to }] (last item is current).
export default function Breadcrumbs({ items = [] }) {
  const { t } = useI18n();
  const all = [{ name: t("common.breadcrumbHome"), to: "/" }, ...items];
  return (
    <nav aria-label="Breadcrumb" className="container-psv pt-28 md:pt-32" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground font-sans">
        {all.map((item, i) => {
          const last = i === all.length - 1;
          return (
            <li key={i} className="flex items-center gap-2">
              {last ? (
                <span className="text-primary font-medium" aria-current="page">{item.name}</span>
              ) : (
                <LangLink to={item.to} className="hover:text-accent transition-colors">
                  {item.name}
                </LangLink>
              )}
              {!last && <ChevronRight className="w-3.5 h-3.5 opacity-50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
